import styled from 'styled-components/macro';

import * as colors from 'components/common/colorConstants';

export const Header = styled.div`
  border-bottom: 1px solid ${colors.decisionTreeButtonHoverBackground};
  padding: 20px 32px;
`;
